import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
import './BusinessIncomeCalculationModal.css';



const AnddonAfter = ({onReset, isEdit, isReset, setIsReset }) => {
  // 添加鼠标按下事件处理
  const handleMouseDown = async (e) => {
    // 阻止默认行为和冒泡
    e.preventDefault();
    e.stopPropagation();
    // 设置重置标志
    setIsReset(true);
    if(onReset) {
      await onReset();
      setIsReset(false)
    }
  };

  return isEdit ? (
    <div onMouseDown={handleMouseDown}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18.5C14.4183 18.5 18 14.9183 18 10.5C18 6.08172 14.4183 2.5 10 2.5C5.58172 2.5 2 6.08172 2 10.5C2 14.9183 5.58172 18.5 10 18.5ZM10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5Z" fill="#6E6E70"/>
            <path d="M12.8286 6.25732L14.2428 7.67154L7.17176 14.7426L5.75754 13.3284L12.8286 6.25732Z" fill="#6E6E70"/>
            <path d="M14.2427 13.3286L12.8285 14.7428L5.75739 7.67176L7.17161 6.25754L14.2427 13.3286Z" fill="#6E6E70"/>
        </svg>
    </div>
    ) : 
    <AnddonAfterHover></AnddonAfterHover>
};

const AnddonAfterHover = () => {
  return (
    <div className="input-hover-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18" fill="none">
          <path d="M11.6935 2.86019L14.6398 5.80647M12.9435 1.61019C13.7571 0.796602 15.0762 0.796602 15.8898 1.61019C16.7034 2.42379 16.7034 3.74288 15.8898 4.55647L4.41667 16.0296H1.5V13.0537L12.9435 1.61019Z" stroke="#6E6E70" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  )
}
/**
 * 特殊金额输入组件
 * 1. 支持千分位分隔符
 * 2. 保留两位小数
 * 3. 负数用()展示
 * 4. 支持用()输入表示负值
 */
const MoneyInput = ({ value, onChange, onBlur, onReset, isMiles, reShowMode, isEntertainment, isPositiveOnly, ...restProps }) => {
  // 内部状态，用于控制输入框显示
  const [displayValue, setDisplayValue] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [isReset, setIsReset] = useState(false);

  // 当外部value变化时更新displayValue
  useEffect(() => {
    setDisplayValue(formatMoney(value));
  }, [value]);

  // 格式化金额：添加千分位、保留两位小数、负数用()表示
  const formatMoney = (val) => {
    if (!val && val !== 0) return '';
    
    // 判断是否为负数
    const isNegative = isNegativeFn(val)
    // 取绝对值
    let absValue = Math.abs(parseFloat(val));
    // 保留两位小数
    absValue = absValue === 0 ? 0 : absValue.toFixed(2);
    
    // 添加千分位分隔符
    const parts = absValue.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    // console.log('parts', parts)
    // console.log('isNegative', isNegative)
    // 组合结果
    return isNegative ? `(${parts.join('.')})` : parts.join('.');
  };

  // 解析输入值：移除千分位分隔符，处理()表示的负数
  const parseMoney = (val) => {
    if (!val) return '';
    
    // 检查是否为()包裹的负数格式
    const isNegative = isNegativeFn(val)
    
    // 移除所有非数字字符（保留小数点）
    let numStr = val.replace(/[^\d.]/g, '');
    
    // 如果是负数，添加负号
    if (isNegative) {
      numStr = '-' + numStr;
    }
    
    return numStr;
  };

  const isNegativeFn = (val) => {
    val = val.toString()
    if(val.startsWith('(') && val.endsWith(')')) {
      return true
    }
    if(val.startsWith('-')) {
      return true
    }
    return false
  }

  // 处理输入变化
  const handleChange = (e) => {
    const inputValue = e.target.value;
    
    // 特殊处理：允许输入()表示负数
    let processedValue = inputValue;
    if(isPositiveOnly) {
      console.log('isPositiveOnly', processedValue)
      // 只能输入大于等于0数字
      processedValue = processedValue.replace(/[^\d.]/g, '');
    }else {

    // 如果用户正在输入左括号，视为负数开始
    if (inputValue === '(') {
      processedValue = '(';
    } 
    // 如果用户输入了完整的括号对，解析为负数
    else if (inputValue.startsWith('(') && inputValue.endsWith(')')) {
      processedValue = inputValue
    }
    // 其他情况，移除非法字符
    else {
      processedValue = inputValue.replace(/[^\d.()-]/g, '');
    }

  }

    
    setDisplayValue(processedValue);
    
    // 将处理后的值传递给onChange回调
    if (onChange) {
      const numericValue = parseMoney(processedValue);
      onChange(numericValue);
    }
  };

  const resetValue = () => {
    // 重置value
    setDisplayValue(formatMoney(value));
  }

  // 处理失焦事件，格式化显示
  const handleBlur = () => {
    // console.log('handleBlur', isEdit, isReset)
    if(isReset) {
      // 如果是重置操作，不执行blur逻辑
      return
    }
    setIsEdit(false)
    const numericValue = parseMoney(displayValue);
    const formattedValue = formatMoney(numericValue);
    setDisplayValue(formattedValue);

    if (onBlur) {
      onBlur(numericValue);
    }
  };

  // 处理聚焦事件，显示原始值便于编辑
  const handleFocus = () => {
    setIsEdit(true)
    // 可以选择在聚焦时保持格式化状态或转为更易编辑的状态
    // 这里保持格式化状态
  };

  const handleMouseOver = (e) => {
    // console.log('handleMouseOver')
    e.preventDefault()
    e.stopPropagation()
    setIsHover(true)
  }

  const handleMouseOut = (e) => {
    e.preventDefault()
    e.stopPropagation()
    // console.log('handleMouseOut')
    setIsHover(false)
  }

  return (
    <Input
      prefix={isMiles ? '' : (isEntertainment 
        ? <span style={{color: '#6E6E70', height: 22, display: 'flex', alignItems: 'center', fontWeight: 400}}><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.05677 13.2727V0.54541H4.87211V13.2727H4.05677ZM6.80109 4.36359C6.74143 3.8598 6.49948 3.46871 6.07524 3.1903C5.651 2.91189 5.13064 2.77268 4.51416 2.77268C4.0634 2.77268 3.66899 2.8456 3.33092 2.99143C2.99617 3.13727 2.73433 3.33779 2.54541 3.593C2.3598 3.8482 2.267 4.13821 2.267 4.46302C2.267 4.7348 2.33163 4.96847 2.46089 5.16402C2.59347 5.35625 2.7625 5.517 2.968 5.64626C3.17349 5.77221 3.38892 5.87661 3.6143 5.95947C3.83968 6.03902 4.04683 6.10365 4.23575 6.15337L5.26984 6.43177C5.53499 6.50138 5.82997 6.59749 6.15479 6.72013C6.48291 6.84276 6.79612 7.01014 7.09442 7.22226C7.39603 7.43106 7.64461 7.69953 7.84016 8.02766C8.0357 8.35578 8.13348 8.75848 8.13348 9.23575C8.13348 9.78594 7.9893 10.2831 7.70095 10.7272C7.41591 11.1714 6.9983 11.5243 6.44811 11.7862C5.90123 12.048 5.2367 12.1789 4.4545 12.1789C3.72533 12.1789 3.09394 12.0613 2.56033 11.826C2.03002 11.5906 1.61241 11.2625 1.30748 10.8416C1.00587 10.4206 0.835183 9.93177 0.79541 9.37496H2.06814C2.10128 9.75943 2.23054 10.0776 2.45592 10.3295C2.68461 10.5781 2.97297 10.7637 3.32098 10.8863C3.6723 11.0056 4.05015 11.0653 4.4545 11.0653C4.92515 11.0653 5.34773 10.9891 5.72226 10.8366C6.09678 10.6808 6.39342 10.4654 6.61217 10.1903C6.83092 9.91189 6.9403 9.58708 6.9403 9.21587C6.9403 8.8778 6.84584 8.6027 6.65692 8.39058C6.468 8.17846 6.21942 8.00611 5.91118 7.87354C5.60294 7.74096 5.26984 7.62496 4.91189 7.52552L3.65905 7.16757C2.86359 6.93888 2.23386 6.61241 1.76984 6.18817C1.30583 5.76392 1.07382 5.20876 1.07382 4.52268C1.07382 3.95261 1.22794 3.45545 1.53618 3.03121C1.84773 2.60365 2.26534 2.27221 2.78902 2.03689C3.31601 1.79825 3.90431 1.67893 4.55393 1.67893C5.21018 1.67893 5.79352 1.79659 6.30393 2.03192C6.81435 2.26392 7.21871 2.58211 7.517 2.98646C7.81861 3.39082 7.9777 3.84986 7.99427 4.36359H6.80109Z" fill="#6E6E70"/>
        </svg>&nbsp;(</span> 
        : <span style={{color: '#6E6E70', height: 22, display: 'flex', alignItems: 'center', fontWeight: 400}}><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.05677 13.2727V0.54541H4.87211V13.2727H4.05677ZM6.80109 4.36359C6.74143 3.8598 6.49948 3.46871 6.07524 3.1903C5.651 2.91189 5.13064 2.77268 4.51416 2.77268C4.0634 2.77268 3.66899 2.8456 3.33092 2.99143C2.99617 3.13727 2.73433 3.33779 2.54541 3.593C2.3598 3.8482 2.267 4.13821 2.267 4.46302C2.267 4.7348 2.33163 4.96847 2.46089 5.16402C2.59347 5.35625 2.7625 5.517 2.968 5.64626C3.17349 5.77221 3.38892 5.87661 3.6143 5.95947C3.83968 6.03902 4.04683 6.10365 4.23575 6.15337L5.26984 6.43177C5.53499 6.50138 5.82997 6.59749 6.15479 6.72013C6.48291 6.84276 6.79612 7.01014 7.09442 7.22226C7.39603 7.43106 7.64461 7.69953 7.84016 8.02766C8.0357 8.35578 8.13348 8.75848 8.13348 9.23575C8.13348 9.78594 7.9893 10.2831 7.70095 10.7272C7.41591 11.1714 6.9983 11.5243 6.44811 11.7862C5.90123 12.048 5.2367 12.1789 4.4545 12.1789C3.72533 12.1789 3.09394 12.0613 2.56033 11.826C2.03002 11.5906 1.61241 11.2625 1.30748 10.8416C1.00587 10.4206 0.835183 9.93177 0.79541 9.37496H2.06814C2.10128 9.75943 2.23054 10.0776 2.45592 10.3295C2.68461 10.5781 2.97297 10.7637 3.32098 10.8863C3.6723 11.0056 4.05015 11.0653 4.4545 11.0653C4.92515 11.0653 5.34773 10.9891 5.72226 10.8366C6.09678 10.6808 6.39342 10.4654 6.61217 10.1903C6.83092 9.91189 6.9403 9.58708 6.9403 9.21587C6.9403 8.8778 6.84584 8.6027 6.65692 8.39058C6.468 8.17846 6.21942 8.00611 5.91118 7.87354C5.60294 7.74096 5.26984 7.62496 4.91189 7.52552L3.65905 7.16757C2.86359 6.93888 2.23386 6.61241 1.76984 6.18817C1.30583 5.76392 1.07382 5.20876 1.07382 4.52268C1.07382 3.95261 1.22794 3.45545 1.53618 3.03121C1.84773 2.60365 2.26534 2.27221 2.78902 2.03689C3.31601 1.79825 3.90431 1.67893 4.55393 1.67893C5.21018 1.67893 5.79352 1.79659 6.30393 2.03192C6.81435 2.26392 7.21871 2.58211 7.517 2.98646C7.81861 3.39082 7.9777 3.84986 7.99427 4.36359H6.80109Z" fill="#6E6E70"/>
        </svg></span>)} 
      suffix={isMiles ? <span style={{color: '#6E6E70', height: 22, lineHeight: '22px'}} className='money-input-suffix'>miles</span> : (isEntertainment ? <span style={{color: '#6E6E70', height: 22, display: 'flex', alignItems: 'center', fontWeight: 400}} className='money-input-suffix'>)</span> : '')}
      value={displayValue}
      onChange={handleChange}
      onPressEnter={reShowMode ? handleBlur : null}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseOut}
      addonAfter={
        reShowMode && (isEdit || isHover) ? <AnddonAfter
          isEdit={isEdit}
          onReset={resetValue}
          isReset={isReset}
          setIsReset={setIsReset}
        ></AnddonAfter> :
        null
      }
      // 根据ReshowMode写入Class Name
      className={reShowMode ? 'income-calculation-field-input' : ''}
      {...restProps}
    />
  );
};

export default MoneyInput;
